<script>
import axios from "axios";

export default {
  name: "UploadDocument",
  props: {
    disableAll: Boolean
  },
  data() {
    return {
      loading: false,
      savedDocuments: [],
      documents: []
    }
  },
  async created() {
    await this.fetchSaved()
  },
  methods: {
    async fetchSaved() {
      let {data} = await axios.get('/api/entry/draft')
      console.log('fetchSaved', data)
      this.documents = [...data.documents]
      this.savedDocuments = [...data.documents]
    },
    async upload(file) {
      if (!file) return
      if (Array.isArray(file)) {
        this.loading = true
        try {
          for (let i in file) {
            await this.upload(file[i])
          }
        } catch (e) {
          console.error(e)
        }
        this.loading = false
        return
      }
      if (file.size > 20971520) {
        alert('ファイルサイズは20MB以下でアップロードしてください')
        return
      }
      let params = new FormData()
      params.append('file', file)
      let {data} = await axios.post('/api/visitor/file/upload', params)
      this.documents.push({
        fileId: data.id,
        key: file.name
      })
      // await this.save()
    },
    async removeDocument(item) {
      this.documents = this.documents.filter(v => v.fileId != item.fileId)
      this.savedDocuments = this.savedDocuments.filter(v => v.fileId != item.fileId)
      // await this.save()
    },
    async save() {
      try {
        let {data} = await axios.post('/api/entry/submit/documents', this.documents)
        console.log(data)
        this.documents = [...data.documents]
        this.savedDocuments = [...data.documents]
        // alert("保存しました")
        bus.$emit("toast", "ファイルを提出しました")
      } catch (e) {
        bus.$emit("error", "保存に失敗しました。しばらくしてから再度試してください")
      }
    }
  },
  filters: {
    fileName(v) {
      return v && v.substring(v.lastIndexOf('/') + 1)
    }
  },
}
</script>

<template>
  <div>

<!--    <v-sheet-->
<!--      class="pa-3 is-dark text-left text&#45;&#45;white align-center text-center" style="color: white;background-color: rgb(26,51,87)"-->
<!--      elevation="3"-->
<!--    >-->
<!--      <v-card-title class="font-weight-bold">試験後に必要な提出書類</v-card-title>-->
<!--      <p class="text-caption-scoped text-left">-->
<!--        〇証明書類の提出が必要な場合は、証明書類をアップロードをお願いいたします。<br/>-->
<!--        養成課程の修了証書<br/>-->
<!--        学位の証明書<br/>-->
<!--        講習修了証-->
<!--      </p>-->

<!--      <span v-for="item in savedDocuments" :key="item.fileId" class="mr-1">-->
<!--            <v-chip :href="item.url" :close="!disableAll"-->
<!--                    v-if="item.url"-->
<!--                    @click:close="removeDocument(item)">-->
<!--              {{ item.key|fileName }}-->
<!--            </v-chip>-->
<!--          </span>-->
<!--      <v-file-input show-size-->
<!--                    label="ファイル選択"-->
<!--                    multiple-->
<!--                    :disabled="disableAll"-->
<!--                    ref="uploader2"-->
<!--                    color="is-dark"-->
<!--                    class="is-dark"-->
<!--                    @change="upload">-->
<!--      </v-file-input>-->

<!--      <v-btn @click="save()" color="primary" rounded>ファイル提出</v-btn>-->
<!--    </v-sheet>-->

<!--    <hr class="ma-5">-->

<!--    <v-sheet-->
<!--      class="ma-auto pa-3 is-dark text-left text&#45;&#45;white align-center text-center" style="color: white; max-width: 800px"-->
<!--      color="blue-grey darken-1"-->
<!--      elevation="3"-->
<!--    >-->
<!--      <v-card-title class="font-weight-bold">試験後に必要な提出書類</v-card-title>-->
<!--      <p class="text-caption-scoped text-left">-->
<!--        〇証明書類の提出が必要な場合は、証明書類をアップロードをお願いいたします。<br/>-->
<!--        養成課程の修了証書<br/>-->
<!--        学位の証明書<br/>-->
<!--        講習修了証-->
<!--      </p>-->

<!--      <span v-for="item in savedDocuments" :key="item.fileId" class="mr-1">-->
<!--            <v-chip :href="item.url" :close="!disableAll"-->
<!--                    v-if="item.url"-->
<!--                    @click:close="removeDocument(item)">-->
<!--              {{ item.key|fileName }}-->
<!--            </v-chip>-->
<!--          </span>-->
<!--      <v-file-input show-size-->
<!--                    label="ファイル選択"-->
<!--                    multiple-->
<!--                    :disabled="disableAll"-->
<!--                    ref="uploader2"-->
<!--                    @change="upload">-->
<!--      </v-file-input>-->

<!--      <v-btn @click="save()" color="primary" rounded>ファイル提出</v-btn>-->
<!--    </v-sheet>-->

<!--    <hr class="ma-5">-->

<!--    <v-card-->
<!--      class="ma-auto border-lg rounded-lg"-->
<!--      style="max-width: 800px; border:solid 6px #1B5E20; background-color: #E8F5E9">-->
    <v-card
      class="ma-auto border-lg rounded-lg"
      elevation="3"
      style="max-width: 800px; border:solid 4px #FFAB00; background-color: #FFF8E1">
            <v-card-title class="font-weight-bold">＜仮合格の方＞試験後に必要な提出書類について</v-card-title>
      <v-card-text>
        <p class="text-caption-scoped text-left" style="text-indent: -1em;padding-left:1em">
          〇証明書類の提出が必要な場合は、証明書類をアップロードをお願いいたします。<br/>
          養成課程の修了証書<br/>
          学位の証明書<br/>
          講習修了証
        </p>
        <!--        <p>アップロード済み書類</p>-->
        <span v-for="item in savedDocuments" :key="item.fileId" class="mr-1">
            <v-chip :href="item.url" :close="!disableAll"
                    v-if="item.url"
                    @click:close="removeDocument(item)">
              {{ item.key|fileName }}
            </v-chip>
          </span>
        <v-file-input show-size
                      label="ファイル選択"
                      multiple
                      :loading="loading"
                      :disabled="disableAll"
                      ref="uploader2"
                      @change="upload">
          <!--          <template #selection>-->
          <!--            <v-btn color="primary" rounded>ファイルアップロード</v-btn>-->
          <!--          </template>-->

        </v-file-input>

        <!--        <input type="file"-->
        <!--               @change="upload"-->
        <!--               class="d-none"-->
        <!--               ref="uploader"/>-->
        <v-btn @click="save()" color="amber accent-4" rounded
               :disabled="loading">ファイル提出</v-btn>
      </v-card-text>
    </v-card>


<!--        <hr class="ma-5">-->

<!--    <v-card-->
<!--      class="ma-auto border-lg rounded-lg"-->
<!--      style="max-width: 800px; border: solid 6px rgb(57, 110, 208)"-->
<!--      color="">-->
<!--      <v-card-title class="font-weight-bold">試験後に必要な提出書類</v-card-title>-->
<!--      <v-card-text>-->
<!--        <p class="text-caption-scoped text-left">-->
<!--          〇証明書類の提出が必要な場合は、証明書類をアップロードをお願いいたします。<br/>-->
<!--          養成課程の修了証書<br/>-->
<!--          学位の証明書<br/>-->
<!--          講習修了証-->
<!--        </p>-->
<!--        &lt;!&ndash;        <p>アップロード済み書類</p>&ndash;&gt;-->
<!--        <span v-for="item in savedDocuments" :key="item.fileId" class="mr-1">-->
<!--            <v-chip :href="item.url" :close="!disableAll"-->
<!--                    v-if="item.url"-->
<!--                    @click:close="removeDocument(item)">-->
<!--              {{ item.key|fileName }}-->
<!--            </v-chip>-->
<!--          </span>-->
<!--        <v-file-input show-size-->
<!--                      label="ファイル選択"-->
<!--                      multiple-->
<!--                      :disabled="disableAll"-->
<!--                      ref="uploader2"-->
<!--                      @change="upload">-->
<!--          &lt;!&ndash;          <template #selection>&ndash;&gt;-->
<!--          &lt;!&ndash;            <v-btn color="primary" rounded>ファイルアップロード</v-btn>&ndash;&gt;-->
<!--          &lt;!&ndash;          </template>&ndash;&gt;-->

<!--        </v-file-input>-->

<!--        &lt;!&ndash;        <input type="file"&ndash;&gt;-->
<!--        &lt;!&ndash;               @change="upload"&ndash;&gt;-->
<!--        &lt;!&ndash;               class="d-none"&ndash;&gt;-->
<!--        &lt;!&ndash;               ref="uploader"/>&ndash;&gt;-->
<!--        <v-btn @click="save()" color="primary" rounded>ファイル提出</v-btn>-->
<!--      </v-card-text>-->
<!--    </v-card>-->

<!--    <hr class="ma-5">-->

<!--    <v-sheet-->
<!--      class="d-flex"-->
<!--      color="teal lighten-3"-->
<!--      height="300"-->
<!--    >-->
<!--      <div class=""><span>試験後に必要な提出書類</span></div>-->
<!--      <sheet-footer>-->
<!--        #4: (2r x 1c)-->
<!--      </sheet-footer>-->
<!--    </v-sheet>-->

<!--    <div class="subTitle"><span>試験後に必要な提出書類</span></div>-->
<!--    <v-sheet style=" ">-->
<!--      &lt;!&ndash;      <v-card-title>試験後に必要な提出書類</v-card-title>&ndash;&gt;-->
<!--      &lt;!&ndash;      <div class="subTitle"><span>試験後に必要な提出書類</span></div>&ndash;&gt;-->
<!--      <v-card-text>-->
<!--        <p class="text-caption-scoped text-left">-->
<!--          〇証明書類の提出が必要な場合は、証明書類をアップロードをお願いいたします。<br/>-->
<!--          養成課程の修了証書<br/>-->
<!--          学位の証明書<br/>-->
<!--          講習修了証-->
<!--        </p>-->
<!--        &lt;!&ndash;        <p>アップロード済み書類</p>&ndash;&gt;-->
<!--        <span v-for="item in savedDocuments" :key="item.fileId" class="mr-1">-->
<!--            <v-chip :href="item.url" :close="!disableAll"-->
<!--                    v-if="item.url"-->
<!--                    @click:close="removeDocument(item)">-->
<!--              {{ item.key|fileName }}-->
<!--            </v-chip>-->
<!--          </span>-->
<!--        <v-file-input show-size-->
<!--                      label="ファイル選択"-->
<!--                      multiple-->
<!--                      :disabled="disableAll"-->
<!--                      ref="uploader2"-->
<!--                      @change="upload">-->
<!--          &lt;!&ndash;          <template #selection>&ndash;&gt;-->
<!--          &lt;!&ndash;            <v-btn color="primary" rounded>ファイルアップロード</v-btn>&ndash;&gt;-->
<!--          &lt;!&ndash;          </template>&ndash;&gt;-->

<!--        </v-file-input>-->

<!--        &lt;!&ndash;        <input type="file"&ndash;&gt;-->
<!--        &lt;!&ndash;               @change="upload"&ndash;&gt;-->
<!--        &lt;!&ndash;               class="d-none"&ndash;&gt;-->
<!--        &lt;!&ndash;               ref="uploader"/>&ndash;&gt;-->
<!--        <v-btn @click="save()" color="primary" rounded>ファイル提出</v-btn>-->
<!--      </v-card-text>-->
<!--    </v-sheet>-->
  </div>
</template>

<style scoped>

</style>
